import { createContext, useState, useEffect } from 'react'
import { getGroupMembership } from "../users/data/membership";
import { getFavorites, removeFavoriteItem, saveFavoriteItem } from "../users/data/preferences";

const UserContext = createContext()

export const UserContextProvider = ({ uniqueId, koId, name, email, department, userName, userProfile, children }) => {
  const [groupMemberships, setGroupMemberships] = useState([]);
  const [groupMembershipNames, setGroupMembershipNames] = useState([])
  

  const loadGroupMemberships = async () => {
    const groups = await getGroupMembership({uniqueId})
    setGroupMemberships(groups)
    const groupNames = groups.map(g => g.displayName.toLowerCase())
    setGroupMembershipNames(groupNames)
  }

  useEffect(() => {
    loadGroupMemberships()
  }, [userProfile]);

  const hasGroupMembership = (groupName) => {
    if (Array.isArray(groupName)) {
      return groupName.some((g) => groupMembershipNames.includes(g.toLowerCase()))
    } else
    return groupMembershipNames.includes(groupName.toLowerCase())
  }

  const contextValue = {
    uniqueId,
    koId, name, email, department, userName, 
    userProfile,
    groupMemberships,
    hasGroupMembership,
    getFavorites,
    saveFavoriteItem,
    removeFavoriteItem
  };

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext